/* unplugin-vue-components disabled */import { render } from "./UserResourcesManager.vue?vue&type=template&id=afe94300"
import script from "./UserResourcesManager.vue?vue&type=script&lang=js"
export * from "./UserResourcesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__